import axios from 'axios';

const taxReportingServiceApi = axios.create({
  baseURL: process.env.TAX_REPORTING_SERVICE_URI,
});

export default taxReportingServiceApi;

export const sendTokenToTaxService = (authorization_code: string, merchant_id: string | undefined) =>
  taxReportingServiceApi.post('/merchant-admin/v1/israel/token/merchant', { authorization_code, merchant_id });

export const getTokenExpirationDate = (merchant_id: string) =>
  taxReportingServiceApi
    .get<{ expires_at: string }>(`/merchant-admin/v1/israel/token/merchant/${merchant_id}`)
    .then(response => response.data);
